import React from "react";
import { Route } from "react-router-dom";
import BranchRoute from "./branch";
import UnitRoute from "./unit";
import CityRoute from "./city";
import ConfigBranchRoute from "./config-branch";
import CustomerRoute from "./customer";
import CustomerHierarchyRoute from "./customer-hierarchy";
import CustomerTypeRoute from "./customer-type";
import DistrictRoute from "./sub-district";
import InfoDistributorRoute from "./info-distributor";
import ItemBrandRoute from "./item-brand";
import ItemCategoryRoute from "./item-category";
import ItemTypeRoute from "./item-type";
import ItemRoute from "./item";
import PostalCodeRoute from "./postal-code";
import ProvinceRoute from "./province";
import SetupHierarchyRoute from "./setup-hierarchy";
import SetupWarehouseRoute from "./setup-warehouse";
import StoreRoute from "./store";
import SubDistrictRoute from "./sub-district";
import SubWarehouseRoute from "./sub-warehouse";
import VehicleRoute from "./vehicle";
import WarehouseRoute from "./warehouse";
import SupplierRoute from "./supplier";
import TaxRoute from "./tax";
import WorkCalendarRoute from "./work-calendar";

export default function MasterRoutes( props ) {
    return (
    <Route path="/master">
       {BranchRoute(props)}
       {CityRoute(props)}
       {ConfigBranchRoute(props)}
       {CustomerRoute(props)}
       {CustomerTypeRoute(props)}
       {CustomerHierarchyRoute(props)}
       {DistrictRoute(props)}
       {InfoDistributorRoute(props)}
       {ItemBrandRoute(props)}
       {ItemCategoryRoute(props)}
       {ItemTypeRoute(props)}
       {ItemRoute(props)}
       {PostalCodeRoute(props)}
       {ProvinceRoute(props)}
       {SetupHierarchyRoute(props)}
       {SetupWarehouseRoute(props)}
       {StoreRoute(props)}
       {SubDistrictRoute(props)}
       {SubWarehouseRoute(props)}
       {SupplierRoute(props)}
       {TaxRoute(props)}
       {UnitRoute(props)}
       {VehicleRoute(props)}
       {WarehouseRoute(props)}
       {WorkCalendarRoute(props)}
    </Route>
    )
}